/// <reference path="../../../dts/declaration.d.ts" />
/// <reference path="../../../dts/interfaces.d.ts" />

import 'component/mholidays';

import 'component.mholidays/header.js';
import 'component.mholidays/index.js';
import 'component.mholidays/search-flight-hotel.js';
import 'component.mholidays/new-deals.js'